/*
 * @file handle display value attachment caption
 */
import { BeethovenDisplayAttributes } from '@padlet/beethoven-client'

// Attachment caption can have a default value
// If there is no custom value for attachment caption set in the post, we will display that default value

const attachmentCaptionForDisplay = ({
  postAttachmentCaption,
  defaultCaption,
}: {
  postAttachmentCaption: string | null | undefined
  defaultCaption: string
}): string => {
  // custom attachment caption can be an empty string when the user doesn't want any caption to be displayed
  // if there is no caption input by the user, the value of postAttachmentCaption is null
  if (postAttachmentCaption === '') {
    return postAttachmentCaption
  }

  return postAttachmentCaption || defaultCaption || ''
}

const defaultLinkCaption = (linkData: BeethovenDisplayAttributes | null): string => {
  if (!linkData) {
    return ''
  }

  // If the link is an audio/video whose title is also "audio"/"video", we don't want to show it since it doesn't look good
  if (
    (linkData.content_category === 'audio' && linkData.title === 'audio') ||
    (linkData.content_category === 'video' && linkData.title === 'video')
  ) {
    return ''
  }

  return linkData.title || linkData.description || ''
}

export default attachmentCaptionForDisplay
export { defaultLinkCaption }
